/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Input, Renderer, ElementRef, Inject, Optional } from '@angular/core';
import { DefaultValueAccessor } from '@angular/forms';
import { COMPOSITION_BUFFER_MODE } from '@angular/forms';
export /*abstract*/ class FormControl extends DefaultValueAccessor {
/**
 * \@internal
 */
public static count = 0;
/**
 * 控件ID: 输入框的 id
 */
id: string;
/**
 * 控件name
 */
name: string;
/**
 * 控件 label
 */
label: string;
/**
 * 是否禁用状态，默认为 false
 */
disabled = false;
/**
 * 定义与输入控件相关联的值，主要用途如下：<ul>
 * <li> type="button", "reset", "submit" - 定义按钮上的显示的文本 </li>
 * <li> type="checkbox", "radio", "image" - 定义与输入相关联的值，如选中时返回该值，不选中时返回空值(即无值) </li>
 * </ul>
 * 注意：<br>
 * 区别于下列情况的输入框，当输入框的type为如下情况时不应该设置value属性，而应该直接使用[(ngModel)]="x"来绑定值：
 * text, password, hidden, textarea, date, time, datetime, month, week, number, tel, email, search, select 等。
 * 
 * <p>注释：&lt;input type="checkbox"&gt; 和 &lt;input type="radio"&gt; 中必须设置 <code>value</code> 属性。</p>
 */
value: any;
/**
 * 额外样式
 */
additionalCls: string;
/**
 * \@internal
 * @return {?}
 */
public static registerControl(): string {
        return 'ant-control-' + (++FormControl.count).toString();
    }
/**
 * @param {?} __renderer
 * @param {?} __elementRef
 * @param {?} __compositionMode
 */
constructor(
private __renderer: Renderer,
private __elementRef: ElementRef,
private __compositionMode: boolean) {
        super(__renderer, __elementRef, __compositionMode);
        this.id = FormControl.registerControl();
    }
/**
 * Write a new value to the element.
 * 
 * \@Override (From ControlValueAccessor interface)
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {

    }
/**
 * \@Override (From ControlValueAccessor interface)
 * @param {?} isDisabled
 * @return {?}
 */
setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, decorators: [{ type: Inject, args: [Renderer, ] }, ]},
{type: ElementRef, decorators: [{ type: Inject, args: [ElementRef, ] }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'name': [{ type: Input },],
'label': [{ type: Input },],
'disabled': [{ type: Input },],
'value': [{ type: Input },],
'additionalCls': [{ type: Input },],
};
}

function FormControl_tsickle_Closure_declarations() {
/**
 * \@internal
 * @type {?}
 */
FormControl.count;
/**
 * @nocollapse
 * @type {?}
 */
FormControl.ctorParameters;
/** @type {?} */
FormControl.propDecorators;
/**
 * 控件ID: 输入框的 id
 * @type {?}
 */
FormControl.prototype.id;
/**
 * 控件name
 * @type {?}
 */
FormControl.prototype.name;
/**
 * 控件 label
 * @type {?}
 */
FormControl.prototype.label;
/**
 * 是否禁用状态，默认为 false
 * @type {?}
 */
FormControl.prototype.disabled;
/**
 * 定义与输入控件相关联的值，主要用途如下：<ul>
 * <li> type="button", "reset", "submit" - 定义按钮上的显示的文本 </li>
 * <li> type="checkbox", "radio", "image" - 定义与输入相关联的值，如选中时返回该值，不选中时返回空值(即无值) </li>
 * </ul>
 * 注意：<br>
 * 区别于下列情况的输入框，当输入框的type为如下情况时不应该设置value属性，而应该直接使用[(ngModel)]="x"来绑定值：
 * text, password, hidden, textarea, date, time, datetime, month, week, number, tel, email, search, select 等。
 * 
 * <p>注释：&lt;input type="checkbox"&gt; 和 &lt;input type="radio"&gt; 中必须设置 <code>value</code> 属性。</p>
 * @type {?}
 */
FormControl.prototype.value;
/**
 * 额外样式
 * @type {?}
 */
FormControl.prototype.additionalCls;
/** @type {?} */
FormControl.prototype.__renderer;
/** @type {?} */
FormControl.prototype.__elementRef;
/** @type {?} */
FormControl.prototype.__compositionMode;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
